import { Injectable } from '@angular/core';

import { ToastService } from '@core/components/toasts/toasts.service';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { HiringConfigModel } from 'services/models/hiring/hiringConfig.model';
import { HttpService } from '../http.service';
import { ServiceBase } from '../servicebase';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class HiringConfigService extends ServiceBase<HiringConfigModel> {
  private hiringConfigSubject = new BehaviorSubject<any>(null);

  constructor(
    http: HttpService,
    private toasterService: ToastService
  ) {
    super('hiringconfig', http);
  }

  createEntity(input: any): HiringConfigModel {
    return HiringConfigModel.create(input);
  }

  getHiringConfigValue(): any {
    return this.hiringConfigSubject.value;
  }

  getConfigs(companyGroupId: string) {
    return this.http.get(`${this.endpoint}/configs/${companyGroupId}`).pipe(
      map((res: any) => {
        this.hiringConfigSubject.next(res.body);
        return this.createEntity(res.body);
      })
    );
  }

  getConfigsWithOrganization(
    companyGroupId: string,
    organizationId?: string,
    disabledLoading: boolean = false
  ) {
    let params = new HttpParams();

    if (organizationId) params = params.set('organizationId', organizationId);

    return this.http
      .get(
        `${this.endpoint}/org-configs/${companyGroupId}`,
        { params },
        null,
        null,
        disabledLoading
      )
      .pipe(
        map((res: any) => {
          this.hiringConfigSubject.next(res.body);
          return this.createEntity(res.body);
        })
      );
  }

  getConfigsWithGroupAndOrganization(companyGroupId: string, organizationId?: string) {
    let params = new HttpParams();

    if (organizationId)
      params = params.set('organizationId', organizationId);

    return this.http.get(`${this.endpoint}/org-configs/${companyGroupId}`, { params }).pipe(
      map((res: any) => {
        this.hiringConfigSubject.next(res.body);
        return this.createEntity(res.body);
      })
    );
  }

  getSpecificOrganizationConfigs(organizationId: string) {
    return this.http.get(`${this.endpoint}/specific-org-configs/${organizationId}`).pipe(
      map((res: any) => {
        this.hiringConfigSubject.next(res.body);
        return res.body;
      })
    );
  }

  saveConfigs(configData: any) {
    return this.http.put(`${this.endpoint}`, configData).pipe(
      map((res: any) => {
        this.toasterService.showSuccess("Configurações de admissão salvas com sucesso!");
        return res;
      })
    );
  }

  replyConfigs(organizationId: string) {
    return this.http.post(`${this.endpoint}`, `"${organizationId}"`).pipe(
      map((res: any) => {
        this.toasterService.showSuccess("Configurações de admissão replicadas com sucesso!");
        return res;
      })
    );
  }
}
